import { oz } from '@weft/utils';
import { LineItemProductCommitmentInputSchema } from '../line-item-product-commitment/line-item-product-commitment-input-schema';
import { LineItemProductVariantInputSchema } from '../line-item-product-variant/line-item-product-variant-input-schema';
import { NewLineItemProductSchema } from './new-line-item-product-schema';

export const LineItemProductInputSchema = oz.object(NewLineItemProductSchema.shape)
  .extend({
    variants: oz.array(LineItemProductVariantInputSchema),
    commitment: LineItemProductCommitmentInputSchema.optional(),
  })
  .partial()
  .openapi('LineItemProductInput');

export type LineItemProductInput = oz.infer<typeof LineItemProductInputSchema>;